$('.image-overlay').on( "click", function(event) {
    if (!$('body').hasClass('drag')){
        var _chil = $(event.target).parent().find('.image-overlay+[data-video-youtube] iframe').attr('src');
        var _chil1 = _chil.replace('autoplay=0', 'autoplay=1');
        $(event.target).parent().find('.image-overlay+[data-video-youtube] iframe').attr('src', _chil1);
        var clone = $(event.target).parent().find('.image-overlay+[data-video-youtube] iframe').clone();
        $(event.target).parent().find('.image-overlay+[data-video-youtube] iframe').remove();
        $(event.target).parent().find('.image-overlay+[data-video-youtube] .fluid-width-video-wrapper').append(clone);
        $(event.target).addClass('hidden-overlay');
    }
});

if($('#tabs-horizontal').length){
    $(document).ready(function(){
        $(window).scroll(function(){
            var x = $(".productView-tab").offset();
            var height = $(".productView-tab").outerHeight();
            var y = document.documentElement.scrollTop;
            var z = (x.top + height);
            if(y > x.top - 50){
                if ( y > z){
                    if($('body').hasClass('product-tab-sticky')) $('body').removeClass('product-tab-sticky');
                } else{
                    if(!$('body').hasClass('product-tab-sticky')) $('body').addClass('product-tab-sticky');
                }
            } else{
                if($('body').hasClass('product-tab-sticky')) $('body').removeClass('product-tab-sticky');
            }
        });
    });
}
